import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import checkAuthStatus from './helpers/checkAuthStatus';
import waitForAuthLoad from './waitForAuthLoad';
import { getAuth } from 'firebase/auth';

const requireAuth = (WrappedComponent) => {
    const ComponentWithAuthentication = (props) => {
        const navigate = useNavigate();

        const [authLoaded, setAuthLoaded] = useState(false);

        useEffect(() => {
            async function init() {
                await waitForAuthLoad();
                console.log('checking auth');

                if (!getAuth().currentUser) {
                    console.log('not logged in');
                    navigate('/login');
                } else {
                    setAuthLoaded(true);
                }
            }

            init();
        }, []);

        return (authLoaded ? <WrappedComponent {...props} /> : <div />);
    };

    return ComponentWithAuthentication;
};

export default requireAuth;